import axios from "axios";
import { API } from "./api";

const TOKEN_KEY = "jonaren_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const admin = axios.create({ baseURL: API, timeout: 15000 });
admin.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const adminLogin = (username, password) => admin.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => admin.get("/admin/me").then((r) => r.data);
export const adminStats = () => admin.get("/admin/stats").then((r) => r.data);
export const adminList = (collection) => {
  const path = { contacts: "/contact", quotes: "/quotes", applications: "/applications", subscribers: "/newsletter" }[collection];
  return admin.get(path).then((r) => r.data);
};
export const adminUpdateStatus = (collection, id, status) => admin.patch(`/admin/${collection}/${id}/status`, { status }).then((r) => r.data);
export const adminDelete = (collection, id) => admin.delete(`/admin/${collection}/${id}`);
